import { render, staticRenderFns } from "./ListLivesTable.vue?vue&type=template&id=387a50e3"
import script from "./ListLivesTable.vue?vue&type=script&lang=js"
export * from "./ListLivesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports